const skillCategories = [
  {
    category: "Programming Languages",
    skills: [
      { name: "Java", iconKey: "java" },
      { name: "Python", iconKey: "python" },
      { name: "C++", iconKey: "cplusplus" },
      { name: "C#", iconKey: "csharp" },
      { name: "JavaScript", iconKey: "javascript" },
      { name: "TypeScript", iconKey: "typescript" },
      { name: "Kotlin", iconKey: "kotlin" },
      { name: "Bash Scripting", iconKey: "bash" },
      { name: "Go", iconKey: "go" },
    ],
  },
  {
    category: "Frameworks & Libraries",
    skills: [
      { name: "ReactJS", iconKey: "react" },
      { name: "NodeJS", iconKey: "nodejs" },
      { name: "Spring Boot", iconKey: "springboot" },
      { name: "Flutter", iconKey: "flutter" },
      { name: "JUnit", iconKey: "junit" },
      { name: "Jest", iconKey: "jest" },
    ],
  },
  {
    category: "Databases",
    skills: [
      { name: "SQL", iconKey: "database" },
      { name: "MongoDB", iconKey: "mongodb" },
      { name: "Firestore", iconKey: "googlecloud" },
    ],
  },
  {
    category: "Tools & Platforms",
    skills: [
      { name: "Git", iconKey: "git" },
      { name: "Swagger", iconKey: "swagger" },
      { name: "VS Code", iconKey: "vscode" },
      { name: "IntelliJ IDEA", iconKey: "intellij" },
      { name: "UML", iconKey: "uml" },
    ],
  },
  {
    category: "Additional Knowledge",
    skills: [
      { name: "80x86 Assembly", iconKey: "assembly" },
      { name: "VHDL", iconKey: "cogs" },
    ],
  },
  {
    category: "Languages",
    skills: [
      { name: "English (Fluent)", iconKey: "language" },
      { name: "French (Intermediate)", iconKey: "language" },
    ],
  },
];

export default skillCategories;
